var $ = require('jquery');

//ローディング画面
var $delayTime = 2000;

$(window).on('load', function(){
    var $loadingAnim = $('#loading'),
        $body = $('body');
   
    $loadingAnim.find('.loading__animLogo').on('animationend', function( e ){
        $body.addClass('loaded');
        $loadingAnim.delay($delayTime).queue(function() {
            $(this).remove();
        });
    });
});

var $header = $('#header');
// Nav Fixed
$(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
        $header.addClass('is-fixed');
    } else {
        $header.removeClass('is-fixed');
    }
});

$(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
        $('#side').addClass('is-fixed');
    } else {
        $('#side').removeClass('is-fixed');
    }
});

// Nav Toggle Button
$('#toggle').on("click", function() {
    $header.toggleClass('is-open');
});

$('.nav_btn').on("click", function() {
    $header.toggleClass('is-open');
});


//スムーズスクロール
$('a[href^="#"]').on("click", function() {
    // スクロールの速度
    var speed = 600; // ミリ秒
    // アンカーの値取得
    var href= $(this).attr("href");
    // 移動先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を数値で取得
    var position = target.offset().top;
    // スムーススクロール
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
});

//スライダーをランダム出力
var rand_obj = $(".swiper-wrapper");
var obj_ary  = [];
rand_obj.find("> *").each(function() {
    obj_ary.push($(this));
});
obj_ary.sort(function() {
    return Math.random() - Math.random();
});
rand_obj.empty();
obj_ary.forEach(function(v) {
    rand_obj.append(v);
});

$('.swiper-slide:gt(4)').remove();

//文字数カット
if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {
    var $setElm = $('.lab__innerSliderSlideInTxt h3, .lab__innerBlockBoxInListChildInner h3');
    var cutFigure = '30'; // カットする文字数
    var afterTxt = '…'; // 文字カット後に表示するテキスト

    $setElm.each(function(){
        var textLength = $(this).text().length;
        var textTrim = $(this).text().substr(0,(cutFigure))

        if(cutFigure < textLength) {
            $(this).html(textTrim + afterTxt).css({visibility:'visible'});
        } else if(cutFigure >= textLength) {
            $(this).css({visibility:'visible'});
        }
    });
}else {
    var $setElm = $('.lab__innerSliderSlideInTxt h3, .lab__innerBlockBoxInListChildInner h3');
    var cutFigure = '50'; // カットする文字数
    var afterTxt = '…'; // 文字カット後に表示するテキスト

    $setElm.each(function(){
        var textLength = $(this).text().length;
        var textTrim = $(this).text().substr(0,(cutFigure))

        if(cutFigure < textLength) {
            $(this).html(textTrim + afterTxt).css({visibility:'visible'});
        } else if(cutFigure >= textLength) {
            $(this).css({visibility:'visible'});
        }
    });
}

//スライドトグル
$('.lab__innerBlockBoxTtl').on("click", function() {
    //クリックされた.accordion_oneの中の.accordion_headerに隣接する.accordion_innerが開いたり閉じたりする。
    $(this).next('.lab__innerBlockBoxIn').slideToggle();
    $(this).toggleClass("open");
});


$('.toggleMenu').on("click", function() {
    var toggleId = $(this).attr('data-menu');
    $('#' + toggleId).toggleClass('is-open');
    $('.mv__innerBg').toggleClass('is-open');
});

$('.close, .mv__innerContentInnerVideoLink').on("click", function() {
    $(this).parents('.mv__innerContent').toggleClass('is-open');
    $('.mv__innerBg').toggleClass('is-open');
});

$('#bnr, .bnr__close').on("click", function() {
    $('.bnr__content').toggleClass('is-open');
    $('.mv__innerBg').toggleClass('is-open');
});

//改行コードをbr
//var str = $('.open__innerBlockListChildMainTeacher figcaption').val();
//$('.open__innerBlockListChildMainTeacher figcaption').html(str.replace(/\r?\n/g, '<br>'));
